import { useDispatch } from "react-redux";

import { showAuthModal } from "store/application/application-action";
import { authModalTabs } from "store/application/application-state";

import IMAGE from "images/login-bg.jpg";

import "./LoginSplash.scss";

export const LoginSplash = (): JSX.Element => {
  const dispatch = useDispatch();

  const onLogin = () => {
    dispatch(showAuthModal({ tab: authModalTabs.login }));
  };

  const onSignUp = () => {
    dispatch(showAuthModal({ tab: authModalTabs.signup }));
  };

  return (
    <div className="loginSplash center">
      <img className="bg" src={IMAGE} alt="" />

      <div className="screen"></div>

      <div className="wrapper">
        <p>You must be logged in to view<br/>the “For You” feed.</p>

        <button
          className="login button"
          onClick={onLogin}
        >Log In</button>

        <hr/>

        <p>Don't have an account?</p>

        <p>
          <button className="signUp" onClick={onSignUp}>Sign Up</button>
        </p>
      </div>
    </div>
  );
};
